<template>
    <div class="center-page">
        <div class="page-top">
            <el-tabs class="mr-20" v-model="activeName" style="flex: 1" @tab-click="handleClick">
                <el-tab-pane v-for="(item,index) in faqList" :key="index" :label="item.name" :name="`${item.id}`"></el-tab-pane>
            </el-tabs>
            <el-input style="width: 320px;" v-model="text" placeholder="请输入想搜索的内容">
                <el-button slot="append" icon="el-icon-search" @click="faqSerch"></el-button>
            </el-input>
        </div>

        <div v-loading="loading">
            <el-collapse class="mt-20">
                <el-collapse-item v-for="item in list" :key="item.id" :title="item.title" :name="item.id">
                    <div class="color-grays" v-html="item.content.replace(/\n/g, '<br/>')"></div>
                </el-collapse-item>
            </el-collapse>
            <el-alert v-if="list.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
    </div>
</template>

<script>
    export default {
        name: "question",
        data() {
            return {
                loading: false,
                activeName: '1',
                number: 1,
                faqList: [],
                list: [],
                text: ''
            }
        },
        created() {
            this.faqLog();
        },
        methods: {
            handleClick() {
                this.text = '';
                this.problemIndex();
            },
            async faqLog(){
                let [e, data] = await this.$api.faqLogApi()
                this.faqList = data.result;
                this.activeName = `${data.result[0].id}`;
                this.problemIndex();
            },
            async problemIndex(){
                this.loading = true;
                let [e, data] = await this.$api.problemIndexApi({
                    mark: this.activeName
                })
                this.loading = false;
                this.list = data.result;
            },
            async faqSerch(){
                this.activeName = '';
                this.loading = true;
                let [e, data] = await this.$api.faqSerchApi({text: this.text});
                this.loading = false;
                this.list = data.result;
            }
        },
    }
</script>

<style scoped lang="less">
    .page-top{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>
